module.exports = __webpack_public_path__ + "16f29b4e803c28ead01634c20de913c4.jpg";